import React from 'react';
import PropTypes from 'prop-types';
import logoSvg from '../public/assets/icons/logo.svg';
import './stylesheets/Sidebar.scss';

const logoHtml = {
  __html: logoSvg
};

function Sidebar({ onLogoClick, currentPath, homePath, returnToDashboardURL, title }) {
  return (
    <div className="Sidebar">
      <div
        id="svg-container"
        dangerouslySetInnerHTML={logoHtml} // eslint-disable-line react/no-danger
      />

      <button title={title} className="Sidebar__Logo" onClick={onLogoClick}>
        <svg>
          <use xlinkHref="#logo" />
        </svg>
      </button>
      <div className="Sidebar__Body">
        {currentPath === homePath && (
          <a href={returnToDashboardURL} className="Sidebar__Body__Dashboard">
            Return to Dashboard
          </a>
        )}
      </div>
    </div>
  );
}

Sidebar.propTypes = {
  currentPath: PropTypes.string,
  returnToDashboardURL: PropTypes.string,
  homePath: PropTypes.string,
  onLogoClick: PropTypes.func,
  title: PropTypes.string
};

Sidebar.defaultProps = {
  currentPath: '',
  onLogoClick: () => {},
  homePath: '',
  returnToDashboardURL: window.location.origin,
  title: ''
};

export default Sidebar;



// WEBPACK FOOTER //
// ./node_modules/@localytics/loc-components/lib/Sidebar.jsx